import React from 'react';
import styled from 'styled-components';

interface TermsModalProps {
  type: 'terms' | 'privacy';
  isOpen: boolean;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ type, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <h2>{type === 'terms' ? 'Kullanım Şartları' : 'Gizlilik Politikası'}</h2>
          <CloseButton onClick={onClose}>✕</CloseButton>
        </ModalHeader>
        
        <ModalBody>
          {type === 'terms' ? (
            <>
              <Section>
                <h3>1. Hizmet Kullanım Şartları</h3>
                <p>• Kullanıcılar 18 yaşından büyük olmalıdır.</p>
                <p>• Platform üzerinden yapılan işlemler kişisel kullanım içindir.</p>
                <p>• Hesap bilgilerinin güvenliği kullanıcının sorumluluğundadır.</p>
              </Section>

              <Section>
                <h3>2. Sorumluluk Reddi</h3>
                <p>• Sinyal hizmeti yatırım tavsiyesi değildir.</p>
                <p>• Tüm yatırım kararları kullanıcının sorumluluğundadır.</p>
                <p>• Geçmiş performans gelecek performansın garantisi değildir.</p>
              </Section>

              <Section>
                <h3>3. Hesap Güvenliği</h3>
                <p>• Güçlü şifre kullanımı zorunludur.</p>
                <p>• İki faktörlü doğrulama önerilir.</p>
                <p>• Şüpheli aktiviteler derhal bildirilmelidir.</p>
              </Section>
            </>
          ) : (
            <>
              <Section>
                <h3>1. Veri Toplama</h3>
                <p>• Kullanıcı kimlik bilgileri</p>
                <p>• İşlem geçmişi ve tercihler</p>
                <p>• Kullanım istatistikleri</p>
              </Section>

              <Section>
                <h3>2. Veri Kullanımı</h3>
                <p>• Hizmet kalitesini iyileştirme</p>
                <p>• Kişiselleştirilmiş deneyim sunma</p>
                <p>• Yasal yükümlülükler</p>
              </Section>

              <Section>
                <h3>3. Veri Güvenliği</h3>
                <p>• End-to-end şifreleme</p>
                <p>• Düzenli güvenlik denetimleri</p>
                <p>• Üçüncü taraf erişim kısıtlamaları</p>
              </Section>
            </>
          )}
        </ModalBody>

        <ModalFooter>
          <AcceptButton onClick={onClose}>Anladım ve Kabul Ediyorum</AcceptButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
`;

const ModalContent = styled.div`
  background: #1a1a2e;
  border-radius: 15px;
  width: 90%;
  max-width: 600px;
  max-height: 80vh;
  border: 1px solid rgba(64, 169, 255, 0.2);
  box-shadow: 0 0 30px rgba(64, 169, 255, 0.1);
`;

const ModalHeader = styled.div`
  padding: 20px;
  border-bottom: 1px solid rgba(64, 169, 255, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    color: #40A9FF;
    margin: 0;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #8B9CC8;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 5px;

  &:hover {
    color: #40A9FF;
  }
`;

const ModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  max-height: calc(80vh - 140px);
`;

const Section = styled.div`
  margin-bottom: 20px;

  h3 {
    color: #40A9FF;
    margin-bottom: 10px;
  }

  p {
    color: #8B9CC8;
    margin: 5px 0;
    line-height: 1.5;
  }
`;

const ModalFooter = styled.div`
  padding: 20px;
  border-top: 1px solid rgba(64, 169, 255, 0.2);
  display: flex;
  justify-content: flex-end;
`;

const AcceptButton = styled.button`
  background: linear-gradient(135deg, #40A9FF 0%, #9D72FF 100%);
  border: none;
  border-radius: 8px;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  font-weight: 500;
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-2px);
  }
`;

export default TermsModal;